<template>
  <div>
    <card class="w-100">
      <el-col :span="24">
        <advertisement-list-component ref="advertisementList" :page-type="pageType"></advertisement-list-component>
      </el-col>
      <el-col :span="12">
        <el-button type="primary" icon="el-icon-finished" v-on:click="showModal(true)"
                   v-if="checkAuth($store.state.account.roleCode, 'ADMIN:BUILDER')">컬럼 선택
        </el-button>
      </el-col>
      <el-col :span="12">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-minus" v-on:click="deleteAll"
                     v-if="checkAuth($store.state.account.roleCode, 'ADMIN:BUILDER')">전체 삭제
          </el-button>
          <el-button type="danger" icon="el-icon-minus" v-on:click="deleteById"
                     v-if="checkAuth($store.state.account.roleCode, 'ADMIN:BUILDER')">선택항목 삭제
          </el-button>
          <el-button type="primary" icon="el-icon-download" v-on:click="downloadExcel"
                     v-if="checkAuth($store.state.account.roleCode, 'ADMIN:BUILDER')">(발주)엑셀 다운로드
          </el-button>
        </div>
      </el-col>
    </card>

    <column-selector-modal ref="columnSelectorModal" :page-type="pageType" v-on:closeModal="showModal"
                           v-on:setColumn="setColumn"></column-selector-modal>

  </div>

</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn, Input, Button, Row, Col} from 'element-ui'
  import AdvertisementListComponent from "../Common/AdvertisementListComponent";
  import OrderProxy from "@/proxies/OrderProxy";
  import ColumnSelectorModal from "../Common/ColumnSelectorModal";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Input)

  export default {
    name: "OrderManagement",
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "이미지 교체 리스트");
    },
    components: {
      AdvertisementListComponent,
      ColumnSelectorModal,
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderFont10CellStyle;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      downloadExcel() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          let param = "";
          this.multipleSelection.forEach(s => {
            param += s.advertisement_seq + ",";
          });
          location.href = "/api/store/excel?authorization=" + $cookies.get('id_token') + "&list=" + param;
        } else {
          alert("발주항목을 선택하세요.");
        }
      },
      deleteById() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          if (confirm("선택하신 발주항목을 삭제하시겠습니까?")) {
            let param = "";
            this.multipleSelection.forEach(s => {
              param += s.advertisement_seq + ",";
            });
            new OrderProxy()
              .deleteById(param)
              .then((response) => {
                this.$refs.advertisementList.getOrderList();
              });
          }
        } else {
          alert("발주항목을 선택하세요.");
        }
      },
      deleteAll() {
        if (confirm("전체 발주항목을 삭제하시겠습니까?")) {
          new OrderProxy()
            .deleteAll()
            .then((response) => {
              this.$refs.advertisementList.getOrderList();
            });
        }
      },
      // 대상 확인창 열기/닫기
      showModal(isShow) {
        this.modals.isShow = isShow;
        if (isShow) {
          this.updateColumn();
          this.$refs.columnSelectorModal.show();
        }
      },
      // 컬럼선택 완료
      setColumn() {
        this.$refs.advertisementList.findAllByUserIdAndPageType(this.pageType);
        this.showModal(false);
      },
      // 컬럼선택 창에서 컬럼설정 다시 조회
      updateColumn() {
        this.$refs.columnSelectorModal.findAllByUserIdAndPageType();
      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      }
    },
    data() {
      return {
        multipleSelection: [],
        modals: {
          isShow: false,
        },
        columns: [],
        pageType: 'orderManagement'
      }
    }
  }
</script>

<style scoped>

</style>
